module.exports = __webpack_public_path__ + "img/icon_signout_failure@2x.85b70970.png";